export default "__VITE_ASSET__BQSVrdxr__"